<template>
  <div>
    <div v-if="isInitialLoadComplete" :key="activeProjectId">
      <li class="nav-item">
          <b-button size="sm" @click="$sidebar.toggleMinimize()" v-b-popover.hover.bottom="'Menu'" class="img-icon img-icon-main-menu d-xl-none ml-2"></b-button>
          <b-button size="sm" v-b-modal.workspace-project-modal v-b-popover.hover.bottom="'Switch the current workspace or project'" >{{mainButtonLabel}}</b-button>
          <b-button size="sm" v-b-modal.project-creation-modal v-b-popover.hover.bottom="'Create a new project'" class="img-icon img-icon-add-plus"></b-button>
      </li>
      <div>
        <b-modal
            id="workspace-project-modal"
            title="Choose the workspace and project"
            centered
            button-size="sm"
            header-class="dflex align-items-center"
            header-bg-variant="success"
            body-bg-variant="secondary"
            footer-bg-variant="secondary"
            @show="reset"
            @hide="reset"
            :no-close-on-backdrop="preventCloseModal"
            :hide-header-close="preventCloseModal"
        >
          <b-container >
            <form>
              <b-row class="mb-1 text-center">
                  <b-col>Workspace</b-col>
                  <b-col>Project</b-col>
              </b-row>
              <b-row class="mb-1">
                  <b-col >
                    <b-form-select
                        v-model="selectedAccount"
                        :options="accounts"
                        @change="accountChanged"
                    ></b-form-select>
                  </b-col>
                  <b-col>
                      <b-form-select
                          v-model="selectedProject"
                          :options="projects"
                      ></b-form-select>
                  </b-col>
              </b-row>
              <b-row class="text-center">
                <b-form-invalid-feedback :state="errorMessage === undefined">
                  {{errorMessage}}
                </b-form-invalid-feedback>
              </b-row>
            </form>
          </b-container>
          <template v-slot:modal-footer="{ cancel }">
              <div class="container w-100 d-flex h-100">
<!--                <div class="p-1">-->
<!--                  <b-form-checkbox-->
<!--                    id="set-default-project-option"-->
<!--                    v-model="setAsDefault"-->
<!--                    name="set-default-project-option"-->
<!--                    :value="true"-->
<!--                    :unchecked-value="false"-->
<!--                    class=""-->
<!--                  >-->
<!--                    Set as default project.-->
<!--                  </b-form-checkbox>-->
<!--                </div>-->
                <div class="ml-auto p-1">
                  <b-button :disabled="preventCloseModal" variant="outline-danger" size="sm" class="ml-auto" @click="cancel">
                    Cancel
                  </b-button>
                </div>
                <div class="p-1">
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    class="btn btn-primary btn-sm"
                    @click="handleOk"
                  >
                    OK
                  </b-button>
                </div>
            </div>
          </template>
        </b-modal>
        <project-creation-modal></project-creation-modal>
      </div>
    </div>
    <!-- <div v-else>
      <li class="nav-item ">
          <b-button disabled size="sm" variant="outline-secondary" class="text-secondary">Loading...</b-button>
      </li>
    </div> -->
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import ProjectCreationModal from '#/ui/Components/ProjectCreationModal.vue';
import { UserUpdateDetailedInfoRequest } from '#/protobuf/service_user_pb';
import { UserUpdateInfo } from '#/protobuf/user_pb';

export default {
  components: {
    ProjectCreationModal,
  },
  data() {
    return {
      selectedAccount: undefined,
      selectedProject: undefined,
      setAsDefault: false,
      errorMessage: undefined,
    };
  },
  computed: {
    ...mapGetters([
      'activeProjectId',
      'isInitialLoadComplete',
      'accountById',
      'activeWorkspaceName',
      'activeProjectName',
    ]),
    preventCloseModal() {
      return this.mainButtonLabel === 'Choose a project';
    },
    mainButtonLabel() {
      if (this.$route.matched.some((record) => record.meta.requiresProject) && this.activeProjectName) {
        return this.activeProjectName;
      }
      if (this.$route.matched.some((record) => record.meta.requiresWorkspace) && this.activeWorkspaceName) {
        return this.activeWorkspaceName;
      }
      return 'Choose a project';
    },
    accounts() {
      return [
        { value: undefined, text: 'Please select an option', disabled: true },
        ...Object.values(this.$store.state.accounts).map((account) => ({
          value: account.accountId,
          text: account.name,
        })),
      ];
    },
    projects() {
      if (!this.selectedAccount) {
        return [];
      }
      const account = this.accountById(this.selectedAccount);
      const projectOptions = account.projectsList.map((project) => ({
        value: project.projectId,
        text: project.name,
      }));
      return [
        { value: undefined, text: 'Please select an option', disabled: true },
        ...projectOptions,
      ];
    },
  },
  methods: {
    reset() {
      this.selectedAccount = this.$store.getters.activeAccountId;
      this.selectedProject = this.$store.getters.activeProjectId;
      this.setAsDefault = false;
      this.errorMessage = undefined;
    },
    accountChanged() {
      this.selectedProject = undefined; // set to null value so it shows need to select project - and so we can invalidate form
    },
    checkFormValidity() {
      if (!this.selectedAccount) {
        console.log('invalid account selection');
        this.errorMessage = 'Please select an account to work in.';
        return false;
      }
      if (!this.selectedProject) {
        console.log('invalid project selection');
        this.errorMessage = 'Please select a project to work in.';
        return false;
      }
      return true;
    },
    async setDefaultProject() {
      const request = new UserUpdateDetailedInfoRequest();
      const info = new UserUpdateInfo();
      info.setUserDefaultProject(this.selectedProject);
      info.setUserDefaultProjectWasUpdated(true);
      request.setInfo(info);
      console.log('setting default project', this.selectedProject);
      return this.$store.dispatch('user/updateDetails', request).then((response) => {
        console.log('set default project', response);
      }).catch((error) => {
        console.error('failed to set default project', error);
        this.errorMessage = 'Could not set default project.';
      });
    },
    async handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }

      // if set default is selected, run that call in the background
      if (this.setAsDefault) {
        await this.setDefaultProject();
        if (this.errorMessage !== undefined) {
          return;
        }
      }

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('workspace-project-modal');
      });

      // route to home page of selected project
      if (this.selectedProject) {
        console.warn('changing active project from', this.$store.activeProjectId, 'to', this.selectedProject);
        this.$router.push({ path: '/home', query: { project: this.selectedProject } });
      }
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
